module.exports = __webpack_public_path__ + "static/media/pic_sc.70078679.png";